import { ErrorCodes } from '@tableau/api-internal-contract-js';
import { InternalTableauError } from './InternalTableauError';

/**
 * This class is used to construct common errors throughout the internal
 * projects (api-core, frelard-desktop-bootstrap, etc.).  It has some duplication with
 * the ErrorHelpers class in api-shared, but is separate due to the need to throw
 * an InternalTableauError vs. an external TableauError.
 */
export class ErrorHelpers {
  /**
   * Helper function that throws an error when a pres model from the platform
   * is in an unexpected format.  Throws error with code PRES_MODEL_PARSING_ERROR.
   *
   * @param modelName the pres model that was malformed.
   */
  public static presModelParsingError(modelName: string): InternalTableauError {
    return new InternalTableauError(ErrorCodes.PRES_MODEL_PARSING_ERROR, `Unexpected format of pres model: ${modelName}`);
  }

  /**
   * Helper function that throws an error when an extension tries to call a command
   * but doesn't have the required permission.
   * Throws error with code PERMISSION_DENIED.
   *
   * @param cmdName the pres model that was malformed.
   */
  public static permissionDeniedError(cmdName: string): InternalTableauError {
    return new InternalTableauError(ErrorCodes.PERMISSION_DENIED, `Missing required permission to run ${cmdName}`);
  }

  /**
   * Helper function that throws an error when a given argument has an invalid value.
   * General case error that throws an error with code INTERNAL_ERROR.
   *
   * @param argumentValue the invalid value.
   * @param argumentName the name of the argument that was invalid.
   */
  /*tslint:disable-next-line */
  public static invalidValueForArgumentError(argumentValue: any, argumentName: string) {
    return new InternalTableauError(ErrorCodes.INTERNAL_ERROR, `${argumentValue} is not a valid value for: ${argumentName}`);
  }

  /**
   * Throws an internal error if argument is null or undefined.
   *
   * @param argumentValue value to verify
   * @param argumentName name of argument to verify
   */
  /*tslint:disable-next-line */
  public static verifyValue(argumentValue: any, argumentName: string) {
    if (argumentValue === null || argumentValue === undefined) {
      throw ErrorHelpers.invalidValueForArgumentError(argumentValue, argumentName);
    }
  }
}
